/* globals lp,Class */
var BlockModule = Class.create(
    lp.ModuleBase,
    lp.ModuleElementMethods,
    lp.ModuleElementPropertiesPanelMethods,
    {
      getLimit: function(page) {
        return page.getConfigValue('sectionCountLimit') || Infinity;
      },
      javascripts: [lp.getPublishedAssetsUrl('modules/lp-block/public/main.js')],

      beforeCreate: function(page, defaults, options) {
        defaults.geometry.size = options.container.getDefaultSectionSize();

        if (page.usedAs() === 'main') {
          defaults.geometry.fitWidthToPage = page.getConfigValue('fitWidthToPageValue');
        } else {
          defaults.geometry.fitWidthToPage = false;
        }
      }
    });

lp.addModule(new BlockModule({
  type      : 'lp-pom-block',
  isAllowedOnPage: function(page) {
    return page.getConfigValue('allowBlockWidget');
  },
  version   : '1.0',
  name      : 'Section',
  usageType : 'page-widget',
  namespace : lp.module.block
}));

module.exports = BlockModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-block/block_module.js
// module id = 507
// module chunks = 0 1